import $j5iPF$react, {useState as $j5iPF$useState, useCallback as $j5iPF$useCallback, useRef as $j5iPF$useRef, useEffect as $j5iPF$useEffect, useContext as $j5iPF$useContext, useMemo as $j5iPF$useMemo} from "react";
import {useLayoutEffect as $j5iPF$useLayoutEffect, useId as $j5iPF$useId, isIOS as $j5iPF$isIOS, chain as $j5iPF$chain, getScrollParent as $j5iPF$getScrollParent} from "@react-aria/utils";
import {useLocale as $j5iPF$useLocale, useMessageFormatter as $j5iPF$useMessageFormatter} from "@react-aria/i18n";
import $j5iPF$domhelpersstyle from "dom-helpers/style";
import $j5iPF$domhelpersqueryoffset from "dom-helpers/query/offset";
import $j5iPF$domhelpersqueryposition from "dom-helpers/query/position";
import $j5iPF$domhelpersqueryscrollLeft from "dom-helpers/query/scrollLeft";
import $j5iPF$domhelpersqueryscrollTop from "dom-helpers/query/scrollTop";
import $j5iPF$domhelpersownerDocument from "dom-helpers/ownerDocument";
import {useInteractOutside as $j5iPF$useInteractOutside, useFocusWithin as $j5iPF$useFocusWithin} from "@react-aria/interactions";
import $j5iPF$reactdom from "react-dom";
import {VisuallyHidden as $j5iPF$VisuallyHidden} from "@react-aria/visually-hidden";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $406a41f4517fdb30$exports = {};

$parcel$export($406a41f4517fdb30$exports, "useOverlayPosition", () => $406a41f4517fdb30$export$d39e1813b3bdd0e1);






const $b0f5ccedd88ed20a$var$AXIS = {
    top: 'top',
    bottom: 'top',
    left: 'left',
    right: 'left'
};
const $b0f5ccedd88ed20a$var$FLIPPED_DIRECTION = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
const $b0f5ccedd88ed20a$var$CROSS_AXIS = {
    top: 'left',
    left: 'top'
};
const $b0f5ccedd88ed20a$var$AXIS_SIZE = {
    top: 'height',
    left: 'width'
};
const $b0f5ccedd88ed20a$var$PARSED_PLACEMENT_CACHE = {
};
// @ts-ignore
let $b0f5ccedd88ed20a$var$visualViewport = typeof window !== 'undefined' && window.visualViewport;
function $b0f5ccedd88ed20a$var$getContainerDimensions(containerNode) {
    let width = 0, height = 0, top = 0, left = 0;
    let scroll = {
    };
    if (containerNode.tagName === 'BODY') {
        var ref;
        width = (ref = $b0f5ccedd88ed20a$var$visualViewport === null || $b0f5ccedd88ed20a$var$visualViewport === void 0 ? void 0 : $b0f5ccedd88ed20a$var$visualViewport.width) !== null && ref !== void 0 ? ref : document.documentElement.clientWidth;
        var ref1;
        height = (ref1 = $b0f5ccedd88ed20a$var$visualViewport === null || $b0f5ccedd88ed20a$var$visualViewport === void 0 ? void 0 : $b0f5ccedd88ed20a$var$visualViewport.height) !== null && ref1 !== void 0 ? ref1 : document.documentElement.clientHeight;
        scroll.top = $j5iPF$domhelpersqueryscrollTop($j5iPF$domhelpersownerDocument(containerNode).documentElement) || $j5iPF$domhelpersqueryscrollTop(containerNode);
        scroll.left = $j5iPF$domhelpersqueryscrollLeft($j5iPF$domhelpersownerDocument(containerNode).documentElement) || $j5iPF$domhelpersqueryscrollLeft(containerNode);
    } else {
        ({ width: width , height: height , top: top , left: left  } = $j5iPF$domhelpersqueryoffset(containerNode));
        scroll.top = $j5iPF$domhelpersqueryscrollTop(containerNode);
        scroll.left = $j5iPF$domhelpersqueryscrollLeft(containerNode);
    }
    return {
        width: width,
        height: height,
        scroll: scroll,
        top: top,
        left: left
    };
}
function $b0f5ccedd88ed20a$var$getScroll(node) {
    return {
        top: node.scrollTop,
        left: node.scrollLeft,
        width: node.scrollWidth,
        height: node.scrollHeight
    };
}
function $b0f5ccedd88ed20a$var$getDelta(axis, offset, size, containerDimensions, padding) {
    let containerScroll = containerDimensions.scroll[axis];
    let containerHeight = containerDimensions[$b0f5ccedd88ed20a$var$AXIS_SIZE[axis]];
    let startEdgeOffset = offset - padding - containerScroll;
    let endEdgeOffset = offset + padding - containerScroll + size;
    if (startEdgeOffset < 0) return -startEdgeOffset;
    else if (endEdgeOffset > containerHeight) return Math.max(containerHeight - endEdgeOffset, -startEdgeOffset);
    else return 0;
}
function $b0f5ccedd88ed20a$var$getMargins(node) {
    let style = window.getComputedStyle(node);
    return {
        top: parseInt(style.marginTop, 10) || 0,
        bottom: parseInt(style.marginBottom, 10) || 0,
        left: parseInt(style.marginLeft, 10) || 0,
        right: parseInt(style.marginRight, 10) || 0
    };
}
function $b0f5ccedd88ed20a$var$parsePlacement(input) {
    if ($b0f5ccedd88ed20a$var$PARSED_PLACEMENT_CACHE[input]) return $b0f5ccedd88ed20a$var$PARSED_PLACEMENT_CACHE[input];
    let [placement, crossPlacement] = input.split(' ');
    let axis = $b0f5ccedd88ed20a$var$AXIS[placement] || 'right';
    let crossAxis = $b0f5ccedd88ed20a$var$CROSS_AXIS[axis];
    if (!$b0f5ccedd88ed20a$var$AXIS[crossPlacement]) crossPlacement = 'center';
    let size = $b0f5ccedd88ed20a$var$AXIS_SIZE[axis];
    let crossSize = $b0f5ccedd88ed20a$var$AXIS_SIZE[crossAxis];
    $b0f5ccedd88ed20a$var$PARSED_PLACEMENT_CACHE[input] = {
        placement: placement,
        crossPlacement: crossPlacement,
        axis: axis,
        crossAxis: crossAxis,
        size: size,
        crossSize: crossSize
    };
    return $b0f5ccedd88ed20a$var$PARSED_PLACEMENT_CACHE[input];
}
function $b0f5ccedd88ed20a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned) {
    let { placement: placement , crossPlacement: crossPlacement , axis: axis , crossAxis: crossAxis , size: size , crossSize: crossSize  } = placementInfo;
    let position = {
    };
    // button position
    position[crossAxis] = childOffset[crossAxis];
    if (crossPlacement === 'center') //  + (button size / 2) - (overlay size / 2)
    // at this point the overlay center should match the button center
    position[crossAxis] += (childOffset[crossSize] - overlaySize[crossSize]) / 2;
    else if (crossPlacement !== crossAxis) //  + (button size) - (overlay size)
    // at this point the overlay bottom should match the button bottom
    position[crossAxis] += childOffset[crossSize] - overlaySize[crossSize];
     /* else {
    the overlay top should match the button top
  } */ 
    // add the crossOffset from props
    position[crossAxis] += crossOffset;
    // this is button center position - the overlay size + half of the button to align bottom of overlay with button center
    let minViablePosition = childOffset[crossAxis] + childOffset[crossSize] / 2 - overlaySize[crossSize];
    // this is button position of center, aligns top of overlay with button center
    let maxViablePosition = childOffset[crossAxis] + childOffset[crossSize] / 2;
    // clamp it into the range of the min/max positions
    position[crossAxis] = Math.min(Math.max(minViablePosition, position[crossAxis]), maxViablePosition);
    // Floor these so the position isn't placed on a partial pixel, only whole pixels. Shouldn't matter if it was floored or ceiled, so chose one.
    if (placement === axis) {
        // If the container is positioned (non-static), then we use the container's actual
        // height, as `bottom` will be relative to this height.  But if the container is static,
        // then it can only be the `document.body`, and `bottom` will be relative to _its_
        // container, which should be as large as boundaryDimensions.
        const containerHeight = isContainerPositioned ? containerOffsetWithBoundary[size] : boundaryDimensions[size];
        position[$b0f5ccedd88ed20a$var$FLIPPED_DIRECTION[axis]] = Math.floor(containerHeight - childOffset[axis] + offset);
    } else position[axis] = Math.floor(childOffset[axis] + childOffset[size] + offset);
    return position;
}
function $b0f5ccedd88ed20a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding) {
    return position.top != null ? Math.max(0, boundaryDimensions.height + boundaryDimensions.top + boundaryDimensions.scroll.top - (containerOffsetWithBoundary.top + position.top) - (margins.top + margins.bottom + padding) // save additional space for margin and padding
    ) : Math.max(0, childOffset.top + containerOffsetWithBoundary.top - (boundaryDimensions.top + boundaryDimensions.scroll.top) - (margins.top + margins.bottom + padding) // save additional space for margin and padding
    );
}
function $b0f5ccedd88ed20a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding, placementInfo) {
    let { placement: placement , axis: axis , size: size  } = placementInfo;
    if (placement === axis) return Math.max(0, childOffset[axis] - boundaryDimensions[axis] - boundaryDimensions.scroll[axis] + containerOffsetWithBoundary[axis] - margins[axis] - margins[$b0f5ccedd88ed20a$var$FLIPPED_DIRECTION[axis]] - padding);
    return Math.max(0, boundaryDimensions[size] + boundaryDimensions[axis] + boundaryDimensions.scroll[axis] - containerOffsetWithBoundary[axis] - childOffset[axis] - childOffset[size] - margins[axis] - margins[$b0f5ccedd88ed20a$var$FLIPPED_DIRECTION[axis]] - padding);
}
function $b0f5ccedd88ed20a$export$6839422d1f33cee9(placementInput, childOffset, overlaySize, scrollSize, margins, padding, flip, boundaryDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, userSetMaxHeight) {
    let placementInfo = $b0f5ccedd88ed20a$var$parsePlacement(placementInput);
    let { size: size , crossAxis: crossAxis , crossSize: crossSize , placement: placement , crossPlacement: crossPlacement  } = placementInfo;
    let position = $b0f5ccedd88ed20a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned);
    let normalizedOffset = offset;
    let space = $b0f5ccedd88ed20a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, placementInfo);
    // Check if the scroll size of the overlay is greater than the available space to determine if we need to flip
    if (flip && scrollSize[size] > space) {
        let flippedPlacementInfo = $b0f5ccedd88ed20a$var$parsePlacement(`${$b0f5ccedd88ed20a$var$FLIPPED_DIRECTION[placement]} ${crossPlacement}`);
        let flippedPosition = $b0f5ccedd88ed20a$var$computePosition(childOffset, boundaryDimensions, overlaySize, flippedPlacementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned);
        let flippedSpace = $b0f5ccedd88ed20a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, flippedPlacementInfo);
        // If the available space for the flipped position is greater than the original available space, flip.
        if (flippedSpace > space) {
            placementInfo = flippedPlacementInfo;
            position = flippedPosition;
            normalizedOffset = offset;
        }
    }
    let delta = $b0f5ccedd88ed20a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, padding);
    position[crossAxis] += delta;
    let maxHeight = $b0f5ccedd88ed20a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding);
    if (userSetMaxHeight && userSetMaxHeight < maxHeight) maxHeight = userSetMaxHeight;
    overlaySize.height = Math.min(overlaySize.height, maxHeight);
    position = $b0f5ccedd88ed20a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, normalizedOffset, crossOffset, containerOffsetWithBoundary, isContainerPositioned);
    delta = $b0f5ccedd88ed20a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, padding);
    position[crossAxis] += delta;
    let arrowPosition = {
    };
    arrowPosition[crossAxis] = childOffset[crossAxis] - position[crossAxis] + childOffset[crossSize] / 2;
    return {
        position: position,
        maxHeight: maxHeight,
        arrowOffsetLeft: arrowPosition.left,
        arrowOffsetTop: arrowPosition.top,
        placement: placementInfo.placement
    };
}
function $b0f5ccedd88ed20a$export$b3ceb0cbf1056d98(opts) {
    let { placement: placement , targetNode: targetNode , overlayNode: overlayNode , scrollNode: scrollNode , padding: padding , shouldFlip: shouldFlip , boundaryElement: boundaryElement , offset: offset , crossOffset: crossOffset , maxHeight: maxHeight  } = opts;
    let container = overlayNode.offsetParent || document.body;
    let isBodyContainer = container.tagName === 'BODY';
    const containerPositionStyle = window.getComputedStyle(container).position;
    let isContainerPositioned = !!containerPositionStyle && containerPositionStyle !== 'static';
    let childOffset = isBodyContainer ? $j5iPF$domhelpersqueryoffset(targetNode) : $j5iPF$domhelpersqueryposition(targetNode, container);
    if (!isBodyContainer) {
        childOffset.top += parseInt($j5iPF$domhelpersstyle(targetNode, 'marginTop'), 10) || 0;
        childOffset.left += parseInt($j5iPF$domhelpersstyle(targetNode, 'marginLeft'), 10) || 0;
    }
    let overlaySize = $j5iPF$domhelpersqueryoffset(overlayNode);
    let margins = $b0f5ccedd88ed20a$var$getMargins(overlayNode);
    overlaySize.width += margins.left + margins.right;
    overlaySize.height += margins.top + margins.bottom;
    let scrollSize = $b0f5ccedd88ed20a$var$getScroll(scrollNode);
    let boundaryDimensions = $b0f5ccedd88ed20a$var$getContainerDimensions(boundaryElement);
    let containerOffsetWithBoundary = boundaryElement.tagName === 'BODY' ? $j5iPF$domhelpersqueryoffset(container) : $j5iPF$domhelpersqueryposition(container, boundaryElement);
    return $b0f5ccedd88ed20a$export$6839422d1f33cee9(placement, childOffset, overlaySize, scrollSize, margins, padding, shouldFlip, boundaryDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, maxHeight);
}




const $57cf16c65f4d0c5c$export$f6211563215e3b37 = new WeakMap();
function $57cf16c65f4d0c5c$export$18fc8428861184da(opts) {
    let { triggerRef: triggerRef , isOpen: isOpen , onClose: onClose  } = opts;
    $j5iPF$useEffect(()=>{
        if (!isOpen) return;
        let onScroll = (e)=>{
            // Ignore if scrolling an scrollable region outside the trigger's tree.
            let target = e.target;
            // window is not a Node and doesn't have contain, but window contains everything
            if (!triggerRef.current || target instanceof Node && !target.contains(triggerRef.current)) return;
            let onCloseHandler = onClose || $57cf16c65f4d0c5c$export$f6211563215e3b37.get(triggerRef.current);
            if (onCloseHandler) onCloseHandler();
        };
        window.addEventListener('scroll', onScroll, true);
        return ()=>{
            window.removeEventListener('scroll', onScroll, true);
        };
    }, [
        isOpen,
        onClose,
        triggerRef
    ]);
}




// @ts-ignore
let $406a41f4517fdb30$var$visualViewport = typeof window !== 'undefined' && window.visualViewport;
function $406a41f4517fdb30$export$d39e1813b3bdd0e1(props) {
    let { direction: direction  } = $j5iPF$useLocale();
    let { targetRef: targetRef , overlayRef: overlayRef , scrollRef: scrollRef = overlayRef , placement: placement = 'bottom' , containerPadding: containerPadding = 12 , shouldFlip: shouldFlip = true , boundaryElement: boundaryElement = typeof document !== 'undefined' ? document.body : null , offset: offset = 0 , crossOffset: crossOffset = 0 , shouldUpdatePosition: shouldUpdatePosition = true , isOpen: isOpen = true , onClose: onClose , maxHeight: maxHeight  } = props;
    let [position, setPosition] = $j5iPF$useState({
        position: {
        },
        arrowOffsetLeft: undefined,
        arrowOffsetTop: undefined,
        maxHeight: undefined,
        placement: undefined
    });
    let deps = [
        shouldUpdatePosition,
        placement,
        overlayRef.current,
        targetRef.current,
        scrollRef.current,
        containerPadding,
        shouldFlip,
        boundaryElement,
        offset,
        crossOffset,
        isOpen,
        direction,
        maxHeight
    ];
    let updatePosition = $j5iPF$useCallback(()=>{
        if (shouldUpdatePosition === false || !isOpen || !overlayRef.current || !targetRef.current || !scrollRef.current || !boundaryElement) return;
        setPosition($b0f5ccedd88ed20a$export$b3ceb0cbf1056d98({
            placement: $406a41f4517fdb30$var$translateRTL(placement, direction),
            overlayNode: overlayRef.current,
            targetNode: targetRef.current,
            scrollNode: scrollRef.current,
            padding: containerPadding,
            shouldFlip: shouldFlip,
            boundaryElement: boundaryElement,
            offset: offset,
            crossOffset: crossOffset,
            maxHeight: maxHeight
        }));
    }, deps);
    // Update position when anything changes
    $j5iPF$useLayoutEffect(updatePosition, deps);
    // Update position on window resize
    $406a41f4517fdb30$var$useResize(updatePosition);
    // Reposition the overlay and do not close on scroll while the visual viewport is resizing.
    // This will ensure that overlays adjust their positioning when the iOS virtual keyboard appears.
    let isResizing = $j5iPF$useRef(false);
    $j5iPF$useLayoutEffect(()=>{
        let timeout;
        let onResize = ()=>{
            isResizing.current = true;
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                isResizing.current = false;
            }, 500);
            updatePosition();
        };
        $406a41f4517fdb30$var$visualViewport === null || $406a41f4517fdb30$var$visualViewport === void 0 ? void 0 : $406a41f4517fdb30$var$visualViewport.addEventListener('resize', onResize);
        return ()=>{
            $406a41f4517fdb30$var$visualViewport === null || $406a41f4517fdb30$var$visualViewport === void 0 ? void 0 : $406a41f4517fdb30$var$visualViewport.removeEventListener('resize', onResize);
        };
    }, [
        updatePosition
    ]);
    let close = $j5iPF$useCallback(()=>{
        if (!isResizing.current) onClose();
    }, [
        onClose,
        isResizing
    ]);
    // When scrolling a parent scrollable region of the trigger (other than the body),
    // we hide the popover. Otherwise, its position would be incorrect.
    $57cf16c65f4d0c5c$export$18fc8428861184da({
        triggerRef: targetRef,
        isOpen: isOpen,
        onClose: onClose ? close : undefined
    });
    return {
        overlayProps: {
            style: {
                position: 'absolute',
                zIndex: 100000,
                ...position.position,
                maxHeight: position.maxHeight
            }
        },
        placement: position.placement,
        arrowProps: {
            style: {
                left: position.arrowOffsetLeft,
                top: position.arrowOffsetTop
            }
        },
        updatePosition: updatePosition
    };
}
function $406a41f4517fdb30$var$useResize(onResize) {
    $j5iPF$useLayoutEffect(()=>{
        window.addEventListener('resize', onResize, false);
        return ()=>{
            window.removeEventListener('resize', onResize, false);
        };
    }, [
        onResize
    ]);
}
function $406a41f4517fdb30$var$translateRTL(position, direction) {
    if (direction === 'rtl') return position.replace('start', 'right').replace('end', 'left');
    return position.replace('start', 'left').replace('end', 'right');
}


var $9f79c4b26f87d454$exports = {};

$parcel$export($9f79c4b26f87d454$exports, "useOverlay", () => $9f79c4b26f87d454$export$ea8f71083e90600f);


const $9f79c4b26f87d454$var$visibleOverlays = [];
function $9f79c4b26f87d454$export$ea8f71083e90600f(props, ref) {
    let { onClose: onClose , shouldCloseOnBlur: shouldCloseOnBlur , isOpen: isOpen , isDismissable: isDismissable = false , isKeyboardDismissDisabled: isKeyboardDismissDisabled = false , shouldCloseOnInteractOutside: shouldCloseOnInteractOutside  } = props;
    // Add the overlay ref to the stack of visible overlays on mount, and remove on unmount.
    $j5iPF$useEffect(()=>{
        if (isOpen) $9f79c4b26f87d454$var$visibleOverlays.push(ref);
        return ()=>{
            let index = $9f79c4b26f87d454$var$visibleOverlays.indexOf(ref);
            if (index >= 0) $9f79c4b26f87d454$var$visibleOverlays.splice(index, 1);
        };
    }, [
        isOpen,
        ref
    ]);
    // Only hide the overlay when it is the topmost visible overlay in the stack.
    let onHide = ()=>{
        if ($9f79c4b26f87d454$var$visibleOverlays[$9f79c4b26f87d454$var$visibleOverlays.length - 1] === ref && onClose) onClose();
    };
    let onInteractOutsideStart = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($9f79c4b26f87d454$var$visibleOverlays[$9f79c4b26f87d454$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
        }
    };
    let onInteractOutside = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($9f79c4b26f87d454$var$visibleOverlays[$9f79c4b26f87d454$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
            onHide();
        }
    };
    // Handle the escape key
    let onKeyDown = (e)=>{
        if (e.key === 'Escape' && !isKeyboardDismissDisabled) {
            e.preventDefault();
            onHide();
        }
    };
    // Handle clicking outside the overlay to close it
    $j5iPF$useInteractOutside({
        ref: ref,
        onInteractOutside: isDismissable ? onInteractOutside : null,
        onInteractOutsideStart: onInteractOutsideStart
    });
    let { focusWithinProps: focusWithinProps  } = $j5iPF$useFocusWithin({
        isDisabled: !shouldCloseOnBlur,
        onBlurWithin: (e)=>{
            if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.relatedTarget)) onClose();
        }
    });
    let onPointerDownUnderlay = (e)=>{
        // fixes a firefox issue that starts text selection https://bugzilla.mozilla.org/show_bug.cgi?id=1675846
        if (e.target === e.currentTarget) e.preventDefault();
    };
    return {
        overlayProps: {
            onKeyDown: onKeyDown,
            ...focusWithinProps
        },
        underlayProps: {
            onPointerDown: onPointerDownUnderlay
        }
    };
}


var $d5e25f6b1b375e64$exports = {};

$parcel$export($d5e25f6b1b375e64$exports, "useOverlayTrigger", () => $d5e25f6b1b375e64$export$f9d5c8beee7d008d);



function $d5e25f6b1b375e64$export$f9d5c8beee7d008d(props, state, ref) {
    let { type: type  } = props;
    let { isOpen: isOpen  } = state;
    // Backward compatibility. Share state close function with useOverlayPosition so it can close on scroll
    // without forcing users to pass onClose.
    $j5iPF$useEffect(()=>{
        if (ref && ref.current) $57cf16c65f4d0c5c$export$f6211563215e3b37.set(ref.current, state.close);
    });
    // Aria 1.1 supports multiple values for aria-haspopup other than just menus.
    // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
    // However, we only add it for menus for now because screen readers often
    // announce it as a menu even for other values.
    let ariaHasPopup = undefined;
    if (type === 'menu') ariaHasPopup = true;
    else if (type === 'listbox') ariaHasPopup = 'listbox';
    let overlayId = $j5iPF$useId();
    return {
        triggerProps: {
            'aria-haspopup': ariaHasPopup,
            'aria-expanded': isOpen,
            'aria-controls': isOpen ? overlayId : null
        },
        overlayProps: {
            id: overlayId
        }
    };
}


var $83f8618cd3e10645$exports = {};

$parcel$export($83f8618cd3e10645$exports, "usePreventScroll", () => $83f8618cd3e10645$export$ee0f7cc6afcd1c18);

// @ts-ignore
const $83f8618cd3e10645$var$visualViewport = typeof window !== 'undefined' && window.visualViewport;
// HTML input types that do not cause the software keyboard to appear.
const $83f8618cd3e10645$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
function $83f8618cd3e10645$export$ee0f7cc6afcd1c18(options = {
}) {
    let { isDisabled: isDisabled  } = options;
    $j5iPF$useLayoutEffect(()=>{
        if (isDisabled) return;
        if ($j5iPF$isIOS()) return $83f8618cd3e10645$var$preventScrollMobileSafari();
        else return $83f8618cd3e10645$var$preventScrollStandard();
    }, [
        isDisabled
    ]);
}
// For most browsers, all we need to do is set `overflow: hidden` on the root element, and
// add some padding to prevent the page from shifting when the scrollbar is hidden.
function $83f8618cd3e10645$var$preventScrollStandard() {
    return $j5iPF$chain($83f8618cd3e10645$var$setStyle(document.documentElement, 'paddingRight', `${window.innerWidth - document.documentElement.clientWidth}px`), $83f8618cd3e10645$var$setStyle(document.documentElement, 'overflow', 'hidden'));
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Prevent default on `touchmove` events inside a scrollable element when the scroll position is at the
//    top or bottom. This avoids the whole page scrolling instead, but does prevent overscrolling.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
// 4. When focusing an input, apply a transform to trick Safari into thinking the input is at the top
//    of the page, which prevents it from scrolling the page. After the input is focused, scroll the element
//    into view ourselves, without scrolling the whole page.
// 5. Offset the body by the scroll position using a negative margin and scroll to the top. This should appear the
//    same visually, but makes the actual scroll position always zero. This is required to make all of the
//    above work or Safari will still try to scroll the page when focusing an input.
// 6. As a last resort, handle window scroll events, and scroll back to the top. This can happen when attempting
//    to navigate to an input with the next/previous buttons that's outside a modal.
function $83f8618cd3e10645$var$preventScrollMobileSafari() {
    let scrollable;
    let lastY = 0;
    let onTouchStart = (e)=>{
        // Store the nearest scrollable parent element from the element that the user touched.
        scrollable = $j5iPF$getScrollParent(e.target);
        if (scrollable === document.documentElement && scrollable === document.body) return;
        lastY = e.changedTouches[0].pageY;
    };
    let onTouchMove = (e)=>{
        // Prevent scrolling the window.
        if (scrollable === document.documentElement || scrollable === document.body) {
            e.preventDefault();
            return;
        }
        // Prevent scrolling up when at the top and scrolling down when at the bottom
        // of a nested scrollable area, otherwise mobile Safari will start scrolling
        // the window instead. Unfortunately, this disables bounce scrolling when at
        // the top but it's the best we can do.
        let y = e.changedTouches[0].pageY;
        let scrollTop = scrollable.scrollTop;
        let bottom = scrollable.scrollHeight - scrollable.clientHeight;
        if (scrollTop <= 0 && y > lastY || scrollTop >= bottom && y < lastY) e.preventDefault();
        lastY = y;
    };
    let onTouchEnd = (e)=>{
        let target = e.target;
        if (target instanceof HTMLInputElement && !$83f8618cd3e10645$var$nonTextInputTypes.has(target.type)) {
            e.preventDefault();
            // Apply a transform to trick Safari into thinking the input is at the top of the page
            // so it doesn't try to scroll it into view. When tapping on an input, this needs to
            // be done before the "focus" event, so we have to focus the element ourselves.
            target.style.transform = 'translateY(-2000px)';
            target.focus();
            requestAnimationFrame(()=>{
                target.style.transform = '';
            });
        }
    };
    let onFocus = (e)=>{
        let target = e.target;
        if (target instanceof HTMLInputElement && !$83f8618cd3e10645$var$nonTextInputTypes.has(target.type)) {
            // Transform also needs to be applied in the focus event in cases where focus moves
            // other than tapping on an input directly, e.g. the next/previous buttons in the
            // software keyboard. In these cases, it seems applying the transform in the focus event
            // is good enough, whereas when tapping an input, it must be done before the focus event. 🤷‍♂️
            target.style.transform = 'translateY(-2000px)';
            requestAnimationFrame(()=>{
                target.style.transform = '';
                // This will have prevented the browser from scrolling the focused element into view,
                // so we need to do this ourselves in a way that doesn't cause the whole page to scroll.
                if ($83f8618cd3e10645$var$visualViewport) {
                    if ($83f8618cd3e10645$var$visualViewport.height < window.innerHeight) // If the keyboard is already visible, do this after one additional frame
                    // to wait for the transform to be removed.
                    requestAnimationFrame(()=>{
                        $83f8618cd3e10645$var$scrollIntoView(target);
                    });
                    else // Otherwise, wait for the visual viewport to resize before scrolling so we can
                    // measure the correct position to scroll to.
                    $83f8618cd3e10645$var$visualViewport.addEventListener('resize', ()=>$83f8618cd3e10645$var$scrollIntoView(target)
                    , {
                        once: true
                    });
                }
            });
        }
    };
    let onWindowScroll = ()=>{
        // Last resort. If the window scrolled, scroll it back to the top.
        // It should always be at the top because the body will have a negative margin (see below).
        window.scrollTo(0, 0);
    };
    // Record the original scroll position so we can restore it.
    // Then apply a negative margin to the body to offset it by the scroll position. This will
    // enable us to scroll the window to the top, which is required for the rest of this to work.
    let scrollX = window.pageXOffset;
    let scrollY = window.pageYOffset;
    let restoreStyles = $j5iPF$chain($83f8618cd3e10645$var$setStyle(document.documentElement, 'paddingRight', `${window.innerWidth - document.documentElement.clientWidth}px`), $83f8618cd3e10645$var$setStyle(document.documentElement, 'overflow', 'hidden'), $83f8618cd3e10645$var$setStyle(document.body, 'marginTop', `-${scrollY}px`));
    // Scroll to the top. The negative margin on the body will make this appear the same.
    window.scrollTo(0, 0);
    let removeEvents = $j5iPF$chain($83f8618cd3e10645$var$addEvent(document, 'touchstart', onTouchStart, {
        passive: false,
        capture: true
    }), $83f8618cd3e10645$var$addEvent(document, 'touchmove', onTouchMove, {
        passive: false,
        capture: true
    }), $83f8618cd3e10645$var$addEvent(document, 'touchend', onTouchEnd, {
        passive: false,
        capture: true
    }), $83f8618cd3e10645$var$addEvent(document, 'focus', onFocus, true), $83f8618cd3e10645$var$addEvent(window, 'scroll', onWindowScroll));
    return ()=>{
        // Restore styles and scroll the page back to where it was.
        restoreStyles();
        removeEvents();
        window.scrollTo(scrollX, scrollY);
    };
}
// Sets a CSS property on an element, and returns a function to revert it to the previous value.
function $83f8618cd3e10645$var$setStyle(element, style, value) {
    let cur = element.style[style];
    element.style[style] = value;
    return ()=>{
        element.style[style] = cur;
    };
}
// Adds an event listener to an element, and returns a function to remove it.
function $83f8618cd3e10645$var$addEvent(target, event, handler, options) {
    target.addEventListener(event, handler, options);
    return ()=>{
        target.removeEventListener(event, handler, options);
    };
}
function $83f8618cd3e10645$var$scrollIntoView(target) {
    // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
    let scrollable = $j5iPF$getScrollParent(target);
    if (scrollable !== document.documentElement && scrollable !== document.body) {
        let scrollableTop = scrollable.getBoundingClientRect().top;
        let targetTop = target.getBoundingClientRect().top;
        if (targetTop > scrollableTop + target.clientHeight) scrollable.scrollTop += targetTop - scrollableTop;
    }
}


var $7b14dc4b86354e5c$exports = {};

$parcel$export($7b14dc4b86354e5c$exports, "ModalProvider", () => $7b14dc4b86354e5c$export$178405afcd8c5eb);
$parcel$export($7b14dc4b86354e5c$exports, "useModalProvider", () => $7b14dc4b86354e5c$export$d9aaed4c3ece1bc0);
$parcel$export($7b14dc4b86354e5c$exports, "OverlayProvider", () => $7b14dc4b86354e5c$export$bf688221f59024e5);
$parcel$export($7b14dc4b86354e5c$exports, "OverlayContainer", () => $7b14dc4b86354e5c$export$b47c3594eab58386);
$parcel$export($7b14dc4b86354e5c$exports, "useModal", () => $7b14dc4b86354e5c$export$33ffd74ebf07f060);


const $7b14dc4b86354e5c$var$Context = /*#__PURE__*/ $j5iPF$react.createContext(null);
function $7b14dc4b86354e5c$export$178405afcd8c5eb(props) {
    let { children: children  } = props;
    let parent = $j5iPF$useContext($7b14dc4b86354e5c$var$Context);
    let [modalCount, setModalCount] = $j5iPF$useState(0);
    let context = $j5iPF$useMemo(()=>({
            parent: parent,
            modalCount: modalCount,
            addModal () {
                setModalCount((count)=>count + 1
                );
                if (parent) parent.addModal();
            },
            removeModal () {
                setModalCount((count)=>count - 1
                );
                if (parent) parent.removeModal();
            }
        })
    , [
        parent,
        modalCount
    ]);
    return(/*#__PURE__*/ $j5iPF$react.createElement($7b14dc4b86354e5c$var$Context.Provider, {
        value: context
    }, children));
}
function $7b14dc4b86354e5c$export$d9aaed4c3ece1bc0() {
    let context = $j5iPF$useContext($7b14dc4b86354e5c$var$Context);
    return {
        modalProviderProps: {
            'aria-hidden': context && context.modalCount > 0 ? true : null
        }
    };
}
/**
 * Creates a root node that will be aria-hidden if there are other modals open.
 */ function $7b14dc4b86354e5c$var$OverlayContainerDOM(props) {
    let { modalProviderProps: modalProviderProps  } = $7b14dc4b86354e5c$export$d9aaed4c3ece1bc0();
    return(/*#__PURE__*/ $j5iPF$react.createElement("div", {
        "data-overlay-container": true,
        ...props,
        ...modalProviderProps
    }));
}
function $7b14dc4b86354e5c$export$bf688221f59024e5(props) {
    return(/*#__PURE__*/ $j5iPF$react.createElement($7b14dc4b86354e5c$export$178405afcd8c5eb, null, /*#__PURE__*/ $j5iPF$react.createElement($7b14dc4b86354e5c$var$OverlayContainerDOM, props)));
}
function $7b14dc4b86354e5c$export$b47c3594eab58386(props) {
    let { portalContainer: portalContainer = document.body , ...rest } = props;
    $j5iPF$react.useEffect(()=>{
        if (portalContainer.closest('[data-overlay-container]')) throw new Error('An OverlayContainer must not be inside another container. Please change the portalContainer prop.');
    }, [
        portalContainer
    ]);
    let contents = /*#__PURE__*/ $j5iPF$react.createElement($7b14dc4b86354e5c$export$bf688221f59024e5, rest);
    return(/*#__PURE__*/ $j5iPF$reactdom.createPortal(contents, portalContainer));
}
function $7b14dc4b86354e5c$export$33ffd74ebf07f060(options) {
    // Add aria-hidden to all parent providers on mount, and restore on unmount.
    let context = $j5iPF$useContext($7b14dc4b86354e5c$var$Context);
    if (!context) throw new Error('Modal is not contained within a provider');
    $j5iPF$useEffect(()=>{
        if ((options === null || options === void 0 ? void 0 : options.isDisabled) || !context || !context.parent) return;
        // The immediate context is from the provider containing this modal, so we only
        // want to trigger aria-hidden on its parents not on the modal provider itself.
        context.parent.addModal();
        return ()=>{
            if (context && context.parent) context.parent.removeModal();
        };
    }, [
        context,
        context.parent,
        options === null || options === void 0 ? void 0 : options.isDisabled
    ]);
    return {
        modalProps: {
            'data-ismodal': !(options === null || options === void 0 ? void 0 : options.isDisabled)
        }
    };
}


var $e574ce2210a97860$exports = {};

$parcel$export($e574ce2210a97860$exports, "DismissButton", () => $e574ce2210a97860$export$2317d149ed6f78c4);
var $5870ac8a269e6de3$exports = {};
var $a5a59de44c333ba6$exports = {};
$a5a59de44c333ba6$exports = JSON.parse("{\"dismiss\":\"تجاهل\"}");


var $50feebb6bb808224$exports = {};
$50feebb6bb808224$exports = JSON.parse("{\"dismiss\":\"Отхвърляне\"}");


var $e83177e29b5408cb$exports = {};
$e83177e29b5408cb$exports = JSON.parse("{\"dismiss\":\"Odstranit\"}");


var $e2c182bad6ce2263$exports = {};
$e2c182bad6ce2263$exports = JSON.parse("{\"dismiss\":\"Luk\"}");


var $c097e483b797e55c$exports = {};
$c097e483b797e55c$exports = JSON.parse("{\"dismiss\":\"Schließen\"}");


var $0d18df414eea1247$exports = {};
$0d18df414eea1247$exports = JSON.parse("{\"dismiss\":\"Απόρριψη\"}");


var $6198858cde361b70$exports = {};
$6198858cde361b70$exports = JSON.parse("{\"dismiss\":\"Dismiss\"}");


var $d609ce5050619dd3$exports = {};
$d609ce5050619dd3$exports = JSON.parse("{\"dismiss\":\"Descartar\"}");


var $56e720a6a6e6a6d1$exports = {};
$56e720a6a6e6a6d1$exports = JSON.parse("{\"dismiss\":\"Lõpeta\"}");


var $6fd05be78eeed1b2$exports = {};
$6fd05be78eeed1b2$exports = JSON.parse("{\"dismiss\":\"Hylkää\"}");


var $1e8ea0f63ec3ba05$exports = {};
$1e8ea0f63ec3ba05$exports = JSON.parse("{\"dismiss\":\"Rejeter\"}");


var $ef8d670a1aff22a8$exports = {};
$ef8d670a1aff22a8$exports = JSON.parse("{\"dismiss\":\"התעלם\"}");


var $ebea4bf8cec8a13f$exports = {};
$ebea4bf8cec8a13f$exports = JSON.parse("{\"dismiss\":\"Odbaci\"}");


var $c5513e010cc556f7$exports = {};
$c5513e010cc556f7$exports = JSON.parse("{\"dismiss\":\"Elutasítás\"}");


var $f18100a5eadc83cd$exports = {};
$f18100a5eadc83cd$exports = JSON.parse("{\"dismiss\":\"Ignora\"}");


var $0bd79d95425d9881$exports = {};
$0bd79d95425d9881$exports = JSON.parse("{\"dismiss\":\"閉じる\"}");


var $800f1181ddced497$exports = {};
$800f1181ddced497$exports = JSON.parse("{\"dismiss\":\"무시\"}");


var $fed9c76a283c706a$exports = {};
$fed9c76a283c706a$exports = JSON.parse("{\"dismiss\":\"Atmesti\"}");


var $7f97210b555a8b40$exports = {};
$7f97210b555a8b40$exports = JSON.parse("{\"dismiss\":\"Nerādīt\"}");


var $07ec6c245088f2ec$exports = {};
$07ec6c245088f2ec$exports = JSON.parse("{\"dismiss\":\"Lukk\"}");


var $e6b11f13579906e7$exports = {};
$e6b11f13579906e7$exports = JSON.parse("{\"dismiss\":\"Negeren\"}");


var $383af37754464bc6$exports = {};
$383af37754464bc6$exports = JSON.parse("{\"dismiss\":\"Zignoruj\"}");


var $64b26eacf9411054$exports = {};
$64b26eacf9411054$exports = JSON.parse("{\"dismiss\":\"Descartar\"}");


var $4d1c371a17c4adab$exports = {};
$4d1c371a17c4adab$exports = JSON.parse("{\"dismiss\":\"Dispensar\"}");


var $4863adeed5a723a4$exports = {};
$4863adeed5a723a4$exports = JSON.parse("{\"dismiss\":\"Revocare\"}");


var $5d6876e7f91ee10a$exports = {};
$5d6876e7f91ee10a$exports = JSON.parse("{\"dismiss\":\"Пропустить\"}");


var $2a5f27f088cb561b$exports = {};
$2a5f27f088cb561b$exports = JSON.parse("{\"dismiss\":\"Zrušiť\"}");


var $98bd94c1a0918168$exports = {};
$98bd94c1a0918168$exports = JSON.parse("{\"dismiss\":\"Opusti\"}");


var $a332aaab81c34c08$exports = {};
$a332aaab81c34c08$exports = JSON.parse("{\"dismiss\":\"Odbaci\"}");


var $d1e8247c80bb74ff$exports = {};
$d1e8247c80bb74ff$exports = JSON.parse("{\"dismiss\":\"Avvisa\"}");


var $21b2557498ae9c36$exports = {};
$21b2557498ae9c36$exports = JSON.parse("{\"dismiss\":\"Kapat\"}");


var $03c01991b0877864$exports = {};
$03c01991b0877864$exports = JSON.parse("{\"dismiss\":\"Скасувати\"}");


var $c39c257709fbcd7a$exports = {};
$c39c257709fbcd7a$exports = JSON.parse("{\"dismiss\":\"取消\"}");


var $a1491919fffafb77$exports = {};
$a1491919fffafb77$exports = JSON.parse("{\"dismiss\":\"關閉\"}");


$5870ac8a269e6de3$exports = {
    "ar-AE": $a5a59de44c333ba6$exports,
    "bg-BG": $50feebb6bb808224$exports,
    "cs-CZ": $e83177e29b5408cb$exports,
    "da-DK": $e2c182bad6ce2263$exports,
    "de-DE": $c097e483b797e55c$exports,
    "el-GR": $0d18df414eea1247$exports,
    "en-US": $6198858cde361b70$exports,
    "es-ES": $d609ce5050619dd3$exports,
    "et-EE": $56e720a6a6e6a6d1$exports,
    "fi-FI": $6fd05be78eeed1b2$exports,
    "fr-FR": $1e8ea0f63ec3ba05$exports,
    "he-IL": $ef8d670a1aff22a8$exports,
    "hr-HR": $ebea4bf8cec8a13f$exports,
    "hu-HU": $c5513e010cc556f7$exports,
    "it-IT": $f18100a5eadc83cd$exports,
    "ja-JP": $0bd79d95425d9881$exports,
    "ko-KR": $800f1181ddced497$exports,
    "lt-LT": $fed9c76a283c706a$exports,
    "lv-LV": $7f97210b555a8b40$exports,
    "nb-NO": $07ec6c245088f2ec$exports,
    "nl-NL": $e6b11f13579906e7$exports,
    "pl-PL": $383af37754464bc6$exports,
    "pt-BR": $64b26eacf9411054$exports,
    "pt-PT": $4d1c371a17c4adab$exports,
    "ro-RO": $4863adeed5a723a4$exports,
    "ru-RU": $5d6876e7f91ee10a$exports,
    "sk-SK": $2a5f27f088cb561b$exports,
    "sl-SI": $98bd94c1a0918168$exports,
    "sr-SP": $a332aaab81c34c08$exports,
    "sv-SE": $d1e8247c80bb74ff$exports,
    "tr-TR": $21b2557498ae9c36$exports,
    "uk-UA": $03c01991b0877864$exports,
    "zh-CN": $c39c257709fbcd7a$exports,
    "zh-TW": $a1491919fffafb77$exports
};





function $e574ce2210a97860$export$2317d149ed6f78c4(props) {
    let { onDismiss: onDismiss  } = props;
    let formatMessage = $j5iPF$useMessageFormatter((/*@__PURE__*/$parcel$interopDefault($5870ac8a269e6de3$exports)));
    let onClick = ()=>{
        if (onDismiss) onDismiss();
    };
    return(/*#__PURE__*/ $j5iPF$react.createElement($j5iPF$VisuallyHidden, null, /*#__PURE__*/ $j5iPF$react.createElement("button", {
        tabIndex: -1,
        "aria-label": formatMessage('dismiss'),
        onClick: onClick
    })));
}


var $3b8a0076b0513838$exports = {};

$parcel$export($3b8a0076b0513838$exports, "ariaHideOutside", () => $3b8a0076b0513838$export$1c3ebcada18427bf);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Keeps a ref count of all hidden elements. Added to when hiding an element, and
// subtracted from when showing it again. When it reaches zero, aria-hidden is removed.
let $3b8a0076b0513838$var$refCountMap = new WeakMap();
function $3b8a0076b0513838$export$1c3ebcada18427bf(targets, root = document.body) {
    let visibleNodes = new Set(targets);
    let hiddenNodes = new Set();
    let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            // If this node is a live announcer, add it to the set of nodes to keep visible.
            if (node instanceof HTMLElement && node.dataset.liveAnnouncer === 'true') visibleNodes.add(node);
            // Skip this node and its children if it is one of the target nodes, or a live announcer.
            // Also skip children of already hidden nodes, as aria-hidden is recursive.
            if (visibleNodes.has(node) || hiddenNodes.has(node.parentElement)) return NodeFilter.FILTER_REJECT;
            // VoiceOver on iOS has issues hiding elements with role="row". Hide the cells inside instead.
            // https://bugs.webkit.org/show_bug.cgi?id=222623
            if (node instanceof HTMLElement && node.getAttribute('role') === 'row') return NodeFilter.FILTER_SKIP;
            // Skip this node but continue to children if one of the targets is inside the node.
            if (targets.some((target)=>node.contains(target)
            )) return NodeFilter.FILTER_SKIP;
            return NodeFilter.FILTER_ACCEPT;
        }
    });
    let hide = (node)=>{
        var ref;
        let refCount = (ref = $3b8a0076b0513838$var$refCountMap.get(node)) !== null && ref !== void 0 ? ref : 0;
        // If already aria-hidden, and the ref count is zero, then this element
        // was already hidden and there's nothing for us to do.
        if (node.getAttribute('aria-hidden') === 'true' && refCount === 0) return;
        if (refCount === 0) node.setAttribute('aria-hidden', 'true');
        hiddenNodes.add(node);
        $3b8a0076b0513838$var$refCountMap.set(node, refCount + 1);
    };
    let node1 = walker.nextNode();
    while(node1 != null){
        hide(node1);
        node1 = walker.nextNode();
    }
    let observer = new MutationObserver((changes)=>{
        for (let change of changes){
            if (change.type !== 'childList' || change.addedNodes.length === 0) continue;
            // If the parent element of the added nodes is not within one of the targets,
            // and not already inside a hidden node, hide all of the new children.
            if (![
                ...visibleNodes,
                ...hiddenNodes
            ].some((node)=>node.contains(change.target)
            )) for (let node2 of change.addedNodes){
                if (node2 instanceof HTMLElement && node2.dataset.liveAnnouncer === 'true') visibleNodes.add(node2);
                else if (node2 instanceof Element) hide(node2);
            }
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
    return ()=>{
        observer.disconnect();
        for (let node of hiddenNodes){
            let count = $3b8a0076b0513838$var$refCountMap.get(node);
            if (count === 1) {
                node.removeAttribute('aria-hidden');
                $3b8a0076b0513838$var$refCountMap.delete(node);
            } else $3b8a0076b0513838$var$refCountMap.set(node, count - 1);
        }
    };
}




export {$406a41f4517fdb30$export$d39e1813b3bdd0e1 as useOverlayPosition, $9f79c4b26f87d454$export$ea8f71083e90600f as useOverlay, $d5e25f6b1b375e64$export$f9d5c8beee7d008d as useOverlayTrigger, $83f8618cd3e10645$export$ee0f7cc6afcd1c18 as usePreventScroll, $7b14dc4b86354e5c$export$178405afcd8c5eb as ModalProvider, $7b14dc4b86354e5c$export$d9aaed4c3ece1bc0 as useModalProvider, $7b14dc4b86354e5c$export$bf688221f59024e5 as OverlayProvider, $7b14dc4b86354e5c$export$b47c3594eab58386 as OverlayContainer, $7b14dc4b86354e5c$export$33ffd74ebf07f060 as useModal, $e574ce2210a97860$export$2317d149ed6f78c4 as DismissButton, $3b8a0076b0513838$export$1c3ebcada18427bf as ariaHideOutside};
//# sourceMappingURL=module.js.map
